import React from 'react';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import cx from 'classnames';
import { isEmpty } from 'lodash/lang';

import { LoadingHandler } from '../../../../../../../common/elements/Loader/LoadingHandler';

import './Sidebar.scss';

export default function Sidebar({ loading, logs, activeScrollId }) {
  return (
    <div className="val-sidebar">
      <div className="val-sidebar-header">Logs</div>
      <LoadingHandler complete={!loading} dark>
        <div className="val-sidebar-items">
          {isEmpty(logs) ? (
            <div className="val-sidebar-items-no-data">There are no logs for this study.</div>
          ) : (
            logs.map(function({ name, status, itemGroupTemplateId }) {
              return (
                <div
                  key={itemGroupTemplateId}
                  onClick={() => document.getElementById(itemGroupTemplateId).scrollIntoView()}
                  className={cx('val-sidebar-item', {
                    'val-sidebar-item-active': itemGroupTemplateId === activeScrollId,
                    'val-sidebar-item-loaded': status === 'LOADED'
                  })}
                >
                  <div className="val-sidebar-item-icon">
                    <FormatListNumberedIcon />
                  </div>
                  <div className="val-sidebar-item-name">{name}</div>
                </div>
              );
            })
          )}
        </div>
      </LoadingHandler>
    </div>
  );
}
